import { Link } from "react-router-dom";

export default function PageHero({
  eyebrow,
  title,
  subtitle,
  image,
  imageAlt,
  primaryCta,
  secondaryCta,
}) {
  return (
    <section
      data-testid="page-hero"
      className="relative overflow-hidden bg-warm-gradient"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="animate-fadeup">
            {eyebrow && (
              <span data-testid="hero-eyebrow" className="eyebrow">
                {eyebrow}
              </span>
            )}
            <h1 className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tight text-[#2b1c10]">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-5 text-base sm:text-lg text-[#6b5945] max-w-xl leading-relaxed">
                {subtitle}
              </p>
            )}
            {(primaryCta || secondaryCta) && (
              <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                {primaryCta && (
                  <Link
                    to={primaryCta.to}
                    data-testid="hero-primary-cta"
                    className="btn-primary"
                  >
                    {primaryCta.label}
                  </Link>
                )}
                {secondaryCta && (
                  <Link
                    to={secondaryCta.to}
                    data-testid="hero-secondary-cta"
                    className="btn-ghost"
                  >
                    {secondaryCta.label}
                  </Link>
                )}
              </div>
            )}
          </div>

          {image && (
            <div className="relative animate-fadeup">
              <div className="photo">
                <img
                  src={image}
                  alt={imageAlt || title}
                  className="w-full h-[320px] sm:h-[460px] object-cover"
                  loading="eager"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
